import requests from './httpService';
const SpecialObservationService = {

  getAllSpecialObservation(id, params = {}) {
    const qp = new URLSearchParams();
    if (params?.classId) qp.set('classId', String(params.classId));
    if (params?.sectionId) qp.set('sectionId', String(params.sectionId));
    const qs = qp.toString();
    return requests.get(`/specialobservation/list/${id}${qs ? `?${qs}` : ''}`);
  },

  creteSpecialobservation(body){
    return requests.post('/specialobservation/add',body); 
  },
  deleteSpecialobservation(body){
    return requests.delete(`/specialobservation/${body._id}`); 
  },

  upadeSpecialobservation(body) {
    return requests.put(`/specialobservation/${body._id}`,body); 
  },
}


export default SpecialObservationService;
